var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingShow),expression:"loadingShow"}],staticClass:"Loading-Box"},[_c('img',{attrs:{"src":require("./load.svg"),"alt":"","srcset":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }